import { useCallback, useState } from "react";
import type { RequestState } from "@redux/state/shared-types";

interface UseAITextGenerationOptions {
  processing: RequestState;
  // Signale lui-même un échec : ne rejette pas, et dit si le texte a été généré. L'état de la génération est remis à zéro
  // par le hook de l'action, une fois son issue rendue
  onGenerate: () => Promise<boolean>;
}

export const useAITextGeneration = ({ processing, onGenerate }: UseAITextGenerationOptions) => {
  const [hasGenerated, setHasGenerated] = useState(false);

  const isGenerating = processing === "pending";

  const handleGenerate = useCallback(async () => {
    if (isGenerating || hasGenerated) return;

    if (await onGenerate()) setHasGenerated(true);
  }, [isGenerating, hasGenerated, onGenerate]);

  return {
    isGenerating,
    isDisabled: isGenerating || hasGenerated,
    hasGenerated,
    handleGenerate,
  };
};
